import { useEffect, useState } from "react";
import { useAuthenticationDataContext } from "../../Helpers/AuthenticationDataProvider";
import useFetchWrapper from "../../Helpers/useFetchWrapper";
import { useOrcidHelper } from "../../Helpers/useOrcidHelper";
import { Article, Props } from "./OrcidArticleSelection.model";

export const useOrcidArticleSelection = ({ onClose, orcidId}: Props) => {
	const [selectedArticles, setSelectedArticles] = useState<Article[]>([]);
	const [orcidArticles, setOrcidArticles] = useState<{ articles: Article[], count: number }>({ articles: [], count: 0 });
	const [spinning, setSpinning] = useState<boolean>(true);

	const { getFullName } = useAuthenticationDataContext();

	const { getWork } = useOrcidHelper();

	const { post } = useFetchWrapper();

	const getArticles = async(userId: string) => {
		const response = await getWork(userId);
		
			const data = await response.json();
		if (data) {
			const { group } = data;
			const articles = group.map((item: any) => ({
				articleId: item["work-summary"][0]["put-code"],
				authors: [getFullName()],
				link: item["work-summary"][0].url?.value,
				publishedIn: item["work-summary"][0]?.source["source-name"]?.value || "ORCID",
				publishingYear: item["work-summary"][0]["publication-date"]?.year?.value,
				tags: [item["work-summary"][0].type],
				title: item["work-summary"][0].title?.title?.value,
			}));
			const count = group.length;
			setOrcidArticles({ articles, count });
			setSpinning(false);
			}
	};

	const onSelectAllArticles = () => {
		const { articles } = orcidArticles;
		if (!areAllArticlesSelected()) setSelectedArticles(articles);
		else setSelectedArticles([]);
	}

	const onSelectArticle = (article: Article) => {
		if (!isArticleSelected(article)) setSelectedArticles([...selectedArticles, article]);
		else setSelectedArticles(selectedArticles.filter(item => item.articleId !== article.articleId))
	}

	const addArticles = async () => {
		const response = await post('/user/profile/articles', { articles: selectedArticles });
		if (response.status === 200) onClose();
	}

	const isArticleSelected = (article: Article) => {
		return selectedArticles.find((item) => item.articleId === article.articleId) ? true : false;
	}

	const areAllArticlesSelected = () => {
		return orcidArticles.articles.length === selectedArticles.length;
	}

	useEffect(() => {
		getArticles(orcidId);
	}, []);

	return {
		addArticles,
		areAllArticlesSelected,
		isArticleSelected,
		onSelectAllArticles,
		onSelectArticle,
		state: {
			orcidArticles,
			selectedArticles,
			spinning
		}
	}
}